<!--
 * @Author: 
 * @Date: 2022-03-08 08:50:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-06-21 13:20:34
 * @FilePath: /Cup2Market/src/views/GoodsDetail/components/DiscoverList.vue
 * @Description: 
-->
<template>
  <div class="discovery-container">
    <List
      class="list"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getData"
    >
      <Cell class="cell" v-for="item in list" :key="item.id">
        <DataComponent :source="item" />
      </Cell>
    </List>
  </div>
</template>

<script>
import DataComponent from "@/views/Discovery/Index/components/Item";
import { getMaterialByGoodsId } from "@/api/discovery";
import { List, Cell } from "vant";
export default {
  components: { DataComponent, List, Cell },
  data() {
    return {
      list: [],
      finished: false,
      loading: false,
      pagination: {
        page: 0,
        size: 10,
      },
    };
  },
  props: {
    goodsId: {
      type: String,
      require: true,
    },
  },
  methods: {
    getData() {
      const params = {
        goodsId: this.goodsId,
      };
      getMaterialByGoodsId(params).then((res) => {
        const data = res.data.map((item) => {
          const obj = { desc_fold: null, desc: item.content, fold: false };
          if (item.content.length > 100) {
            obj.desc_fold = item.content.slice(0, 100);
            obj.fold = false;
          }
          return { ...item, ...obj, goodsId: null };
        });
        this.list.push(...data);
        this.loading = false;
        // if (data.length < this.pagination.size) {
        this.finished = true;
        // } else {
        //   this.pagination.page++
        // }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.discovery-container {
  .cell {
    position: relative;
    padding: 0;
    & + .cell {
      padding-top: 24px;
    }
    &::after {
      display: none;
    }
    .discovery-item {
      margin-bottom: 0;
    }
  }
  .discovery-item {
    & /deep/ .item {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
